import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchEvents = async (params = {}) => {
  const { data } = await api.get("/events", { params });
  return data;
};

export const fetchEvent = async (slug) => {
  const { data } = await api.get(`/events/${slug}`);
  return data;
};

export const fetchTaxonomy = async () => {
  const { data } = await api.get("/events/categories");
  return data;
};

export const joinWaitlist = async (email) => {
  const { data } = await api.post("/waitlist", { email });
  return data;
};

export const waitlistCount = async () => {
  const { data } = await api.get("/waitlist/count");
  return data;
};

export const createReservation = async (payload) => {
  const { data } = await api.post("/reservations", payload);
  return data;
};

export const listReservations = async (email) => {
  const { data } = await api.get("/reservations", { params: { email } });
  return data;
};
